<template>

  <b-nav-item-dropdown
    v-if="!loader && role !== 'super-admin'"
    id="notificationbell"
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="notificationCount"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Notifications
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{ notificationCount }} {{ $t('DEBTIA_NOTIFICATIONS') }}
        </b-badge>
      </div>
    </li>
    <b-overlay
      id="overlay-background"
      :show="overlayLoader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <!-- Notifications -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
        @ps-scroll-y="scrolledY"
        @ps-y-reach-end="reachedBottom"
      >
        <!-- Account Notification -->
        <b-link
          v-for="(notification, index) in data.list"
          :key="index"
          @click="itemclicked(notification)"
        >
          <b-media>
            <template #aside>
              <b-avatar
                size="32"
                :variant="notification.type"
              >
                <feather-icon :icon="notification.icon" />
              </b-avatar>
            </template>
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ notification.title }}
              </span>
            </p>
            <small class="notification-text">{{ notification.description }}</small>

          </b-media>
        </b-link>
        <div
          v-if="notifictionNextLink"
          class="d-flex justify-content-center mb-1"
        >
          <b-spinner label="Loading More ..." />
        </div>
      </vue-perfect-scrollbar>
    </b-overlay>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar,
  // BButton,
  BOverlay, BSpinner,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import { reactive, ref } from '@vue/composition-api'
import constants from '@/app-configs/constants'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    // BButton,
    BOverlay,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  setup() {
    const role = JSON.parse(localStorage.getItem('userData')).role[0]
    const loader = ref(true)
    const scrollStatus = ref(false)
    const data = reactive({ list: [] })

    const notifications = reactive([])
    const notificationCount = ref(0)
    const notifictionNextLink = ref('task-list/get-list?page=1')
    /* eslint-disable global-require */

    const systemNotifications = [
      {
        title: 'Server down',
        subtitle: 'USA Server is down due to hight CPU usage',
        type: 'light-danger',
        icon: 'XIcon',
      },
      {
        title: 'Sales report generated',
        subtitle: 'Last month sales report generated',
        type: 'light-success',
        icon: 'CheckIcon',
      },
      {
        title: 'High memory usage',
        subtitle: 'BLR Server using high memory',
        type: 'light-warning',
        icon: 'AlertTriangleIcon',
      },
    ]

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const taskList = async () => {
      if (notifictionNextLink.value && scrollStatus.value) {
        const notification = await axios.get(notifictionNextLink.value)
        if (notification.status === 200) {
          loader.value = false
          scrollStatus.value = false
          notifictionNextLink.value = notification.data.data.next_page_url
          notifications.push(...notification.data.data.data)
          data.list = notifications
          notifications.counter = notifications.filter(x => x.read === 0)
          // console.log('notification.data.data.total ', )
          notificationCount.value = notification.data.data.pagination.total
        }
      }
    }
    const overlayLoader = ref(false)

    const taskAction = async (id, taskId, status, index) => {
      overlayLoader.value = true
      await axios.post(`${constants.baseUrl}/approve-debt-case`, {
        debt_case_id: id,
        status,
        taskId,
      }).then(() => {
        notifications[index].action = status === 1 ? 'accepted' : 'declined'
        notifications[index].actionLable = status === 1 ? 'Accepted' : 'Declined'
        notifications.splice(index, 1, notifications[index])
        data.list = notifications
        overlayLoader.value = false
      })
    }

    const accept = ref(1)
    const decline = ref(2)

    return {
      scrollStatus,
      taskList,
      loader,
      notificationCount,
      notifictionNextLink,
      notifications,
      systemNotifications,
      perfectScrollbarSettings,
      role,
      taskAction,
      overlayLoader,
      accept,
      decline,
      data,
    }
  },
  created() {
    this.scrollStatus = true
    this.taskList()
    EventBus.$on('refreshNotificationTotal', () => {
      this.taskList()
    })
  },
  methods: {
    scrolledY() {
      this.scrollStatus = true
    },
    reachedBottom() {
      this.taskList()
    },
    itemclicked(notification) {
      console.log('this.$route.name ', this.$route.name)
      this.$router.push({ name: 'tasklist-item-details', params: { id: notification.id } })
      // document.getElementById('').click()
      const item = document.getElementById('notificationbell')
      item.classList.remove('show')
      document.querySelector('#notificationbell > ul').classList.remove('show')
      document.querySelector('#notificationbell > a').setAttribute('aria-expanded', false)
      // this.$router.go()
      if (this.$route.name === 'tasklist-item-details') {
        this.$router.go()
      }
    },
  },
}
</script>

<style>

</style>
